import Vue from 'vue/dist/vue.esm.js';
import {formatPrice} from '../utility/formatPrice'
import {parseCartResponse, serializeCartForEvent} from '../utility/parseCartResponse'

Vue.component('cart', {
    template: `#cart`,
    delimiters: ['[[', ']]'],
    props: {
        initialCart: {
            required: true,
            type: Object,
        },
        locale: {
            required: true,
            type: String,
        },
        currency: {
            required: true,
            type: String,
        },
        removeRowUrl: {
            required: true,
            type: String,
        },
        incrementUrl: {
            required: true,
            type: String,
        },
        decrementUrl: {
            required: true,
            type: String,
        },
        promocodeUrl: {
            required: true,
            type: String,
        },
        removePromocodeUrl: {
            required: true,
            type: String,
        },
        freeDeliveryOver: {
            required: true,
            type: Number,
        },
        freeBookOver: {
            required: true,
            type: Number,
        },
        free_delivery_price: {
            required: true
        },
        exchangeRate: {
            required: true,
            type: String,
        },
        exchangeRateMode: {
            required: true,
            type: String,
        },
        convertMode: {
            required: true,
            type: String,
        },
        showEurFirst: {
            required: false,
            type: String,
            default: '0'
        }
    },
    updated() {
        $('[data-bs-toggle="tooltip"]').tooltip('dispose');
        $('[data-bs-toggle="tooltip"]').tooltip();
    },

    mounted() {

        setTimeout(() => {
            $('[data-bs-toggle="tooltip"]').tooltip('dispose');
            $('[data-bs-toggle="tooltip"]').tooltip();
        }, 1000);
        
        EventManager.listen('item-added', this.cartUpdated);
        EventManager.listen('cart-updated', this.cartUpdated);
        EventManager.listen('item-removed', this.cartUpdated);
    },

    data() {
        return {
            cart: this.initialCart,
            showPromocode: false,
            hasPromocode: !!this.initialCart.promocode,
            promocode: this.initialCart.promocode,
            promocodeText: null,
            promocodeError: null,
            quantityAlert: {
                visible: false,
                productName: '',
            },
        }
    },

    methods: {
        formatDualPrice(price) {
            return formatPrice(price, this.exchangeRate, this.exchangeRateMode, this.convertMode, true, this.showEurFirst);
        },
        syncPromocodeFromCart(cart) {
            this.hasPromocode = !!(cart && cart.promocode);
            this.promocode = cart?.promocode || null;
            this.promocodeText = cart?.promocode?.code || null;
        },
        cartUpdated(data) {
            const cart = parseCartResponse(data);
            if (!cart) {
                return;
            }

            this.cart = cart;
            this.syncPromocodeFromCart(cart);
        },

        removeRow(row) {
            let _self = this;
            $.ajax({
                data: {id: row.id},
                url: _self.removeRowUrl,
                method: 'POST',
                success: function (result) {
                    EventManager.fire('item-removed', result.cart);

                    let event = {
                        event: 'remove_from_cart',
                        eventData: result.variant,
                        action: 'CartPage',
                    }
                    EventManager.fire('gtm-event',event);
                },
            });
        },
        addVariantQuantity(row) {
            let _self = this;
            let url = _self.incrementUrl;
            if(row.isAddedAsSpecialProductFromCart){
                url += "?source=cart";
            }
            $.ajax({
                data: {id: row.variantId},
                url: url,
                method: 'POST',
                success: function (result) {
                    if(result.success !== false){
                        _self.quantityAlert.visible = false;
                        EventManager.fire('item-added', result.cart);
                        EventManager.fire('cart-updated', result.cart);

                        let event = {
                            event: 'add_to_cart',
                            eventData: result.variant,
                            unique_event_id: result.unique_event_id,
                            action: 'CartPage',
                            cart:  result.cart
                        }

                        EventManager.fire('gtm-event', event);

                    }else{
                        _self.quantityAlert.visible = true;
                        _self.quantityAlert.productName = row.name;
                    }
                },
            });
        },
        decrementVariantQuantity(row) {
            let _self = this;
            let url = _self.decrementUrl;
            if(row.isAddedAsSpecialProductFromCart){
                url += "?source=cart";
            }
            $.ajax({
                data: {id: row.id},
                url: url,
                method: 'POST',
                success: function (result) {
                    _self.quantityAlert.visible = false;
                    EventManager.fire('item-removed', result.cart);
                    let event = {
                        event: 'remove_from_cart',
                        eventData: result.variant,
                        action: 'CartPage',
                    }
                    EventManager.fire('gtm-event',event);
                },
            });
        },

        incrementRowQuantity(row) {
            if (row.quantity > 99) {
                return;
            }
            this.addVariantQuantity(row);

        },

        decrementQuantity(row) {
            if (row.quantity === 1) {
                return;
            }
            this.decrementVariantQuantity(row);
        },
        formattedRowPrice(row) {
            return this.formattedPrice(row.totalPrice);
        },
        formattedPrice(price) {
            return new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currency}).format(price);
        },
        qualifiesForFreeDelivery() {
            return this.cart.total >= this.freeDeliveryOver;
        },
        qualifiesForFreeBook() {
            return this.cart.total >= this.freeBookOver;
        },

        togglePromocodeField() {
            this.showPromocode = !this.showPromocode;
        },
        applyPromocode() {
            let _self = this;
            $.ajax({
                data: {code: _self.promocodeText},
                url: _self.promocodeUrl,
                method: 'POST',
                success: function (result) {
                    if (result.success === false) {
                        _self.promocodeError = result.error;
                        return;
                    }

                    const cart = parseCartResponse(result);
                    if (!cart) {
                        return;
                    }

                    _self.promocodeError = null;
                    _self.cart = cart;
                    _self.syncPromocodeFromCart(cart);
                    EventManager.fire('cart-updated', serializeCartForEvent(cart));
                },
            });
        },

        removePromocode() {
            let _self = this;
            $.ajax({
                url: _self.removePromocodeUrl,
                method: 'POST',
                success: function (result) {
                    const cart = parseCartResponse(result);
                    if (!cart) {
                        return;
                    }

                    _self.cart = cart;
                    _self.syncPromocodeFromCart(cart);
                    EventManager.fire('cart-updated', serializeCartForEvent(cart));
                },
            });
        },



        concatenateAttributeValues(attributes) {
            let str = '';
            for (let [index,attribute] of attributes.entries()) {
                if(index !== 0){
                    str += ', '
                }
                if(attribute.showUnit){
                    str += attribute.unit + ' x '
                }
                str +=  ' ' + attribute.value;

            }
            return str;
        }
    },

    computed: {
        formattedTotal() {
            return this.formattedPrice(this.cart.total)
        },
        formattedOriginalTotal() {
            return this.formattedPrice(this.cart.originalTotal)
        },
        amountToFreeShipping() {
            return this.formattedPrice(this.freeDeliveryOver - this.cart.total);
        },
        amountToFreeBook() {
            return this.formattedPrice(this.freeBookOver - this.cart.total);
        },
        formattedDiscount() {
            return '-' + this.formattedPrice(this.cart.discount);
        },
        formattedDiscountWithoutPromocode() {
            return '-' + this.formattedPrice(this.cart.discount);
        },
        formattedPromocodeDiscount() {
            return '-' + this.formatDualPrice(this.cart.totalPromocodeDiscount);
        },
        formattedLoyaltyProgramDiscount() {
            return '-' + this.formattedPrice(this.cart.loyaltyProgramDiscount);
        },

        priceLeftForFreeDelivery() {
            if (this.cart.promocode?.freeDelivery) {
                return 0;
            }
            return this.free_delivery_price - this.cart.total
        },
        priceLeftForFreeDeliveryFormatted() {
            return this.formattedPrice(this.free_delivery_price - this.cart.total)
        },
        priceLeftForFreeDeliveryPercentage() {
            let priceLeft = this.free_delivery_price - this.cart.total;
            let percentage = (100 - ((100 * priceLeft) / this.free_delivery_price).toFixed(0));
            percentage = percentage > 100 ? 100 : percentage;
            return "width:" + percentage + "%"
        }
    }
});
